@if (!isLoading) { @if (paragraphParts.length >= 2) {
<p class="paragraph">
    <span class="text-blue">{{ paragraphParts[0] }}</span>
    <br />
    <span class="text-green">{{ paragraphParts[1] }}</span>
</p>
} @else {
<p class="paragraph" [innerText]="paragraphParts[0]"></p>
} }
<div originalContent>
    <ng-content></ng-content>
</div>
